/**
 * 用于更新 state 中的状态信息
 */
import * as types from '@/store/mutation-types'
// import Vue from "vue";
const mutations = {
    [types.UPDATE_TOKEN] (state, data) {
        state.token = data
        if (data) {
            sessionStorage.setItem('token', data)
        } else {
            sessionStorage.removeItem('token')
        }
    },
    [types.UPDATE_COURT_NAME] (state, data) {
        state.courtName = data
        if (data) {
            sessionStorage.setItem('courtName', data)
        } else {
            sessionStorage.removeItem('courtName')
        }
    },
    [types.UPDATE_USERNAME] (state, data) {
        state.username = data
        if (data) {
            sessionStorage.setItem('username', data)
        } else {
            sessionStorage.removeItem('username')
        }
    },
    [types.UPDATE_JOBNUMBER] (state, data) {
        state.jobNumber = data
        if (data) {
            sessionStorage.setItem('jobNumber', data)
        } else {
            sessionStorage.removeItem('jobNumber')
        }
    },
    [types.UPDATE_WINDOW] (state, data) {
        state.window = data
        if (data) {
            sessionStorage.setItem('window', data)
        } else {
            sessionStorage.removeItem('window')
        }
    },
    [types.UPDATE_SERVICE] (state, data) {
        state.service = data
        if (data) {
            sessionStorage.setItem('service', data)
        } else {
            sessionStorage.removeItem('service')
        }
    },
    [types.UPDATE_QUEUENO] (state, data) {
        state.queueno = data
        if (data) {
            sessionStorage.setItem('queueno', data)
        } else {
            sessionStorage.removeItem('queueno')
        }
    },


}

export default mutations